// extracted by mini-css-extract-plugin
export default {"helpBanner":"styles-module_helpBanner__Y5US_k","sampleImages":"styles-module_sampleImages__GSfwmP","imgBanner":"styles-module_imgBanner__FbObbq"};